<template>
  <div class="calc-main">
    <template v-if="error">
      <CalcError @close="handleCloseError" />
    </template>
    <template>
      <CalcHeader :count="data?.banks_amount" :mode="mode" @mode="mode = $event" />
      <CalcLoader v-show="loading" />
      <CalcParams
        v-if="mode === 'calc'"
        :model="target"
        :loading="loading"
        :options="data?.options_form_param"
        @input="handleTarget"
      />
      <CalcQuiz v-else :input="data?.options_form_param" @input="handleTarget" />
      <CalcBottom :count="data?.banks_amount" />
      <CalcBanks :loading="loading" :logos="data?.logos" />
    </template>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import CalcHeader from './calc-header.vue'
import CalcBanks from './calc-banks.vue'
import CalcLoader from './calc-loader.vue'
import { Widget } from '@/types/Widget'
import CalcError from './calc-error.vue'
import CalcQuiz from './calc-quiz.vue'
import CalcParams from './calc-params.vue'
import CalcBottom from './calc-bottom.vue'

interface Data {
  loading: boolean
  data: Widget | null
  mode: 'calc' | 'quiz'
  error: boolean
  target: number | null
}

const DATA_ENDPOINT: string = process.env['VUE_APP_DATA_ENDPOINT']
const WIDGET_SCRIPT: string = process.env['VUE_APP_WIDGET_SCRIPT']

function getWidgetData() {
  const el = document.getElementById('widgetConfig')
  const endpoint = el?.getAttribute('data-endpoint') || DATA_ENDPOINT
  const token = el?.getAttribute('data-wid') || ''
  const res = fetch(endpoint + '?a=%2Fload-free-widget', {
    headers: { 'Api-Token': token, 'Content-type': 'application/json' },
  }).then((response) => response.json())
  return res
}

export default defineComponent({
  name: 'CalcMain',
  components: {
    CalcHeader,
    CalcBanks,
    CalcLoader,
    CalcError,
    CalcParams,
    CalcQuiz,
    CalcBottom,
  },
  data(): Data {
    return {
      loading: true,
      data: null,
      error: false,
      target: null,
      mode: 'quiz'
    }
  },

  methods: {
    handleTarget(target: number) {
      this.target = target
    },

    handleCloseError() {
      this.error = false
    },

    async fetchData() {
      try {
        this.loading = true
        const res = await getWidgetData()
        if (res.status === 'error') throw new Error()
        this.data = res.data
        this.loading = false
        this.error = false
      } catch (error) {
        this.error = true
        console.error('Error fetching data:', error)
      }
    },

    async loadWidget() {
      this.loading = true

      const preloader = document.querySelector('script[src="app.js"]')

      const script = document.createElement('script')
      script.src = WIDGET_SCRIPT
      script.type = 'text/javascript'
      document.body.appendChild(script)
      script.onload = function () {
        preloader?.remove()
      }
    },
  },

  watch: {
    target() {
      if (this.target) {
        window.n2182nfd3hN_target = this.target
        window.n2182nfd3hN_mode = this.mode
        this.loadWidget()
      }
    },
  },

  mounted() {
    this.fetchData()
  },
})
</script>

<style lang="scss" scoped>
.calc-main {
  container: bank-card / inline-size;
  position: relative;
  border-radius: 30px;
  border: 1px solid #0097ce;
}

@media (max-width: 960px) {
  .calc-main {
    margin-top: 50px;
  }
}
</style>
